module.exports = __webpack_public_path__ + "static/media/knee_transparent.54c53a85.png";